import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

@Injectable()
export class ParameterService {
    hasInit:boolean = false;
  params:Params;

  getParameter(key:string):string {
      if(!this.hasInit)
        return undefined;

      if(this.params.hasOwnProperty(key))
        return this.params[key];
      
      return undefined;
  }

  init(params:Params){
    this.params = params;
    this.hasInit = true;
  }
}